import { SaveButton, useTranslate } from "react-admin";
import { CircularProgress } from "@mui/material";

const CustomSaveButton = ({
  isLoading,
  disabled
}: {
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  const translate = useTranslate();
  return (
    <SaveButton
      label={isLoading ? translate("common.saving") : translate("common.save")}
      startIcon={null}
      icon={<div />}
      disabled={isLoading || disabled}
      sx={{
        height: "36px",
        "& .MuiButton-endIcon": {
          marginRight: "-12px"
        },
        "& .MuiCircularProgress-root": {
          display: "none"
        },
        "& .CustomMuiCircularProgress": {
          display: "flex"
        }
      }}
      endIcon={
        isLoading ? (
          <CircularProgress
            style={{
              width: "18px",
              height: "18px",
              color: "rgba(0, 0, 0, 0.3)"
            }}
            className="CustomMuiCircularProgress"
          />
        ) : null
      }
    />
  );
};

export default CustomSaveButton;
